import React from 'react';

export const ZashaniLoader = ({ small = false }) => (
    <span className={`zashani-loader ${small ? 'small' : ''}`} aria-hidden="true">
        <svg viewBox="0 0 96 96" focusable="false">
            <path d="M22 24h52L38 72h36" />
        </svg>
    </span>
);

export const ButtonSpinner = () => <ZashaniLoader small />;

export const PanelLoader = ({ label = 'Cargando informacion' }) => (
    <div className="panel-loader" role="status" aria-live="polite">
        <ZashaniLoader />
        <span>{label}</span>
    </div>
);

export const TableEmptyState = ({ loading, emptyText = 'Sin registros para mostrar.' }) => (
    <div className={`table-state ${loading ? 'is-loading' : ''}`}>
        {loading ? (
            <>
                <ZashaniLoader small />
                <span>Cargando datos...</span>
            </>
        ) : (
            <span>{emptyText}</span>
        )}
    </div>
);

export const MetricSkeleton = ({ count = 4 }) => (
    <div className="metric-grid">
        {Array.from({ length: count }).map((_, index) => (
            <article className="metric-card metric-skeleton" key={index} style={{ '--delay': `${index * 70}ms` }}>
                <span />
                <strong />
            </article>
        ))}
    </div>
);
